import { render, staticRenderFns } from "./LoanOverviewWidget.vue?vue&type=template&id=4145d644&lang=pug&"
import script from "./LoanOverviewWidget.vue?vue&type=script&lang=js&"
export * from "./LoanOverviewWidget.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports